import { CLASS_NAME } from 'constants/class-names'
import { CSSUtils } from 'utils/css'
import { StylesUtils } from 'utils/styles'
import { ComponentBase } from 'utils/abstract-classes/component-base'
import { Nullable } from 'constants/types'

const { header: headerClass, vehicleFinder: vehicleFinderClass } = CLASS_NAME

export class HeaderOffsetService extends ComponentBase {
    private elements: Record<string, Nullable<HTMLElement>> = {}

    private classMap = {
        [headerClass._]: 'header',
        [headerClass.breaking]: 'breakingNews',
        [vehicleFinderClass.wrapper]: 'vehicleFinder'
    }

    public constructor(el: HTMLElement) {
        super()
        const offset = 2
        let totalHeight = 0

        this.getElements(`.${headerClass.offset}`).forEach(
            (item: HTMLElement) => {
                Object.keys(this.classMap).forEach((className: string) => {
                    if (CSSUtils.checkClass(item, className)) {
                        this.elements[this.classMap[className]] = item
                    }
                })
            }
        )

        if (
            this.elements['header'] &&
            this.elements['header'].getBoundingClientRect().top > offset
        ) {
            totalHeight = Math.round(this.elements['header'].clientHeight)
        }

        if (this.elements['breakingNews']) {
            totalHeight += Math.round(
                this.elements['breakingNews'].clientHeight
            )
        }

        if (this.elements['vehicleFinder']) {
            if (
                this.elements['header'] &&
                this.elements['header'].getBoundingClientRect().top === 0
            ) {
                totalHeight = Math.round(this.elements['header'].clientHeight)
            }
            totalHeight += Math.round(
                this.elements['vehicleFinder'].clientHeight
            )
        }

        StylesUtils.style(el, 'top', `${totalHeight}px`)
    }
}
